module.exports = __webpack_public_path__ + "img/ic_covidcheck.bf589efd.svg";